import {action, makeAutoObservable, observable} from 'mobx'
import {Hub} from 'yougile-model'
import {createUseStore} from '@containers/hooks'
import {State} from './types'

export class ImportFromFileStore {
  state: State = {
    open: false,
    errors: [],
    loading: false,
    imported: false,
    workBook: undefined,
    projectNames: new Set(),
    columnTitles: [],
    isDragEnter: false,
    selectedFile: undefined,
    canStartImport: false,
    isErrorPopupOpen: false,
    unregisteredUsers: [],
    columnTitlesMap: {},
    processedColumns: [],
    loadingProgress: 0
  }
  setOpen: (state: boolean) => void
  project: Hub
  stickerNamesMap: Record<string, string> = {}

  constructor(setOpen: (state: boolean) => void) {
    this.setOpen = setOpen
    makeAutoObservable(this, {
      state: observable.shallow,
      setLoadingProgress: action.bound
    })
  }

  setOpenState(open: boolean): void {
    this.state.open = open
  }

  setLoading(loading: boolean): void {
    this.state.loading = loading
  }

  setCanStartImport(canStart: boolean): void {
    this.state.canStartImport = canStart
  }

  setLoadingProgress(percent: number): void {
    this.state.loadingProgress = Math.floor(percent * 100)
  }

  onDragEnter(): void {
    this.state.isDragEnter = true
  }

  onDrop(): void {
    this.state.isDragEnter = false
  }

  onDragLeave(): void {
    this.state.isDragEnter = false
  }

  setIsErrorPopupVisible(state: boolean): void {
    this.state.isErrorPopupOpen = state
  }

  clearFile(): void {
    this.state.selectedFile = undefined
    this.state.workBook = undefined
    this.state.columnTitles = []
    this.state.canStartImport = false
    this.state.imported = false
    this.state.errors = []
    this.state.columnTitlesMap = {}
    this.state.processedColumns = []
    this.stickerNamesMap = {}
  }

  close(): void {
    this.setOpen(false)
    this.state.loading = false
    this.state.imported = false
    this.state.errors = []
    this.state.projectNames = new Set()
    this.state.selectedFile = undefined
    this.state.columnTitles = []
    this.state.columnTitlesMap = {}
    this.state.processedColumns = []
    this.stickerNamesMap = {}
  }
}

const [ImportFromFileContext, useImportFromFileStore] =
  createUseStore(ImportFromFileStore)
export {ImportFromFileContext, useImportFromFileStore}
